<template>
  <header class="head" :class="newStyle ? 'login-header' : 'new-login-header'">
    <div class="main">
      <div class="head-title"></div>
      <div class="head-time">
        <div class="year" v-if="dataTime.year">
          {{ dataTime.year }}年{{ dataTime.month }}月{{ dataTime.day }}日
        </div>
        <div class="time" v-if="dataTime.year">
          {{ dataTime.h }}:{{ dataTime.m }}:{{ dataTime.s }}
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "LoginHeader",
  setup() {
    // 右上角时间
    const dataTime = ref({});

    const route = useRoute();
    const newStyle = ref(false);
    watch(
      () => route.fullPath,
      (newVal) => {
        newStyle.value = newVal == "/";
      },
      { immediate: true }
    );

    // 每秒钟更新一次时间
    const updateTime = setInterval(() => {
      const date = new Date();
      const year = date.getFullYear();
      const month =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      const day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
      const h = date.getHours() >= 10 ? date.getHours() : "0" + date.getHours();
      const m =
        date.getMinutes() >= 10 ? date.getMinutes() : "0" + date.getMinutes();
      const s =
        date.getSeconds() >= 10 ? date.getSeconds() : "0" + date.getSeconds();
      dataTime.value.year = year;
      dataTime.value.month = month;
      dataTime.value.day = day;
      dataTime.value.h = h;
      dataTime.value.m = m;
      dataTime.value.s = s;
    }, 1000);

    return {
      dataTime,
      updateTime,
      newStyle,
    };
  },
};
</script>

<style scoped lang="less">
.head {
  width: 100%;
  height: 6.25rem;
  color: #fff;

  .main {
    width: 85rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 1.4375rem;
  }

  .head-title {
    width: 30rem;
    height: 4.625rem;
    background-image: url("@/assets/images/logo.png");
    background-size: 100%;
    background-repeat: no-repeat;

    .title2 {
      font-size: 1.6rem;
    }
  }

  .head-time {
    text-align: center;

    .year {
      font-size: 1.125rem;
    }

    .time {
      font-size: 1.5rem;
    }
  }
}

.login-header {
  position: absolute;
}

.new-login-header {
  background-image: url(../assets/images/head/head-bg.png);
  background-size: 100% 100%;
}
</style>
